// Every query parameter of a URL into our apps. Emailed links, ad links and shipped apps hold these: never change a value.
export enum QueryParamOptions {
  ClaimToken = 'claimToken',
  OobCode = 'oobCode',
  Premium = 'premium',
  OnboardingPremium = 'onboarding-premium',
  OnboardingDesktop = 'onboarding-desktop',
  Purchase = 'purchase',
  PriceType = 'type',
  ConnectionToken = 'connectionToken',
  Search = 'search',
  C = 'c',
  ExternalId = 'externalId',
  DesktopChallenge = 'desktopChallenge',
  // WorkOS names it: the sign-in an AI app started, carried through /login back to the MCP Login URI.
  ExternalAuthId = 'external_auth_id',
  // Consumed straight off the desktop deep link, never carried onward.
  DesktopCode = 'desktopCode',
  Featurebase = 'featurebase',
  ReturnTo = 'return_to',
  // The one-time link of an email change, mailed by the backend.
  EmailChangeToken = 'token',
  // The settings section to open on load, e.g. when the desktop shell sends an account change to the browser.
  Settings = 'settings',
  // Sign-in callbacks: the backend hands the provider's token back on the url, which the app strips once read.
  IdToken = 'idToken',
  GoogleIdToken = 'googleIdToken',
  IsNewUser = 'isNewUser',
  ProviderError = 'error',
  Intent = 'intent',
  ReauthError = 'reauthError',
}

export enum UtmParameters {
  Ref = 'ref',
  UtmSource = 'utm_source',
  UtmMedium = 'utm_medium',
  UtmCampaign = 'utm_campaign',
  UtmContent = 'utm_content',
  UtmTerm = 'utm_term',
  InitialUtmSource = 'initial_utm_source',
  InitialUtmCampaign = 'initial_utm_campaign',
  InitialUtmMedium = 'initial_utm_medium',
  InitialUtmTerm = 'initial_utm_term',
  InitialUtmContent = 'initial_utm_content',
}
